// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/ai.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from enum omnios.v1.AgentRunStatus
 */
export const AgentRunStatus = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.AgentRunStatus",
  [
    {no: 0, name: "AGENT_RUN_STATUS_UNSPECIFIED"},
    {no: 1, name: "PENDING"},
    {no: 2, name: "RUNNING"},
    {no: 3, name: "AWAITING_APPROVAL"},
    {no: 4, name: "COMPLETED"},
    {no: 5, name: "FAILED"},
    {no: 6, name: "CANCELLED"},
  ],
);

/**
 * @generated from enum omnios.v1.AgentStepKind
 */
export const AgentStepKind = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.AgentStepKind",
  [
    {no: 0, name: "AGENT_STEP_KIND_UNSPECIFIED"},
    {no: 1, name: "THINKING"},
    {no: 2, name: "TOOL_CALL"},
    {no: 3, name: "TOOL_RESULT"},
    {no: 4, name: "MESSAGE"},
    {no: 5, name: "APPROVAL_REQUEST"},
    {no: 6, name: "APPROVAL_RESPONSE"},
  ],
);

/**
 * Agent invocation -- run an agent (Party with kind=AGENT) on a task
 * The agent uses its configured tools, model, and permissions
 *
 * @generated from message omnios.v1.AgentRun
 */
export const AgentRun = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AgentRun",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agent_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "invoker_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(AgentRunStatus) },
    { no: 6, name: "task_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "context", kind: "message", T: Struct },
    { no: 10, name: "steps", kind: "message", T: AgentStep, repeated: true },
    { no: 11, name: "result", kind: "message", T: Struct },
    { no: 20, name: "started_at", kind: "message", T: Timestamp },
    { no: 21, name: "completed_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.AgentStep
 */
export const AgentStep = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AgentStep",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(AgentStepKind) },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "data", kind: "message", T: Struct },
    { no: 5, name: "timestamp", kind: "message", T: Timestamp },
    { no: 10, name: "seq", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "up_to_date", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "closed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ClassifyMessageRequest
 */
export const ClassifyMessageRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ClassifyMessageRequest",
  () => [
    { no: 1, name: "message_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agent_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.Classification
 */
export const Classification = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Classification",
  () => [
    { no: 1, name: "case_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "reasoning", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "metadata", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.SuggestReplyRequest
 */
export const SuggestReplyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SuggestReplyRequest",
  () => [
    { no: 1, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "context", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ReplyChunk
 */
export const ReplyChunk = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReplyChunk",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_final", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ExtractOrderRequest
 */
export const ExtractOrderRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExtractOrderRequest",
  () => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "context", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ExtractedOrderRow
 */
export const ExtractedOrderRow = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExtractedOrderRow",
  () => [
    { no: 1, name: "raw_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "parsed_attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ExtractOrderResponse
 */
export const ExtractOrderResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ExtractOrderResponse",
  () => [
    { no: 1, name: "rows", kind: "message", T: ExtractedOrderRow, repeated: true },
    { no: 2, name: "source_format", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "metadata", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.MatchProductsRequest
 */
export const MatchProductsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MatchProductsRequest",
  () => [
    { no: 1, name: "rows", kind: "message", T: ExtractedOrderRow, repeated: true },
    { no: 2, name: "agent_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "context", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.ProductMatch
 */
export const ProductMatch = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ProductMatch",
  () => [
    { no: 1, name: "row_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "triage_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "requested_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "selling_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "converted_quantity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "conversion_factor", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "conversion_reasoning", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.MatchProductsResponse
 */
export const MatchProductsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MatchProductsResponse",
  () => [
    { no: 1, name: "matches", kind: "message", T: ProductMatch, repeated: true },
    { no: 2, name: "total_rows", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "auto_matched", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "needs_review", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "no_match", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "total_time_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.EntityMention
 */
export const EntityMention = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.EntityMention",
  () => [
    { no: 1, name: "entity_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entity_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SendAgentMessageRequest
 */
export const SendAgentMessageRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SendAgentMessageRequest",
  () => [
    { no: 1, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mentions", kind: "message", T: EntityMention, repeated: true },
    { no: 5, name: "page_context", kind: "message", T: Struct },
    { no: 6, name: "profile_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SendAgentMessageResponse
 */
export const SendAgentMessageResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SendAgentMessageResponse",
  () => [
    { no: 1, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "agent_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.InvokeAgentRequest
 */
export const InvokeAgentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.InvokeAgentRequest",
  () => [
    { no: 1, name: "agent_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "task_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "context", kind: "message", T: Struct },
    { no: 4, name: "work_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "model_override", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.StreamAgentRunRequest
 */
export const StreamAgentRunRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StreamAgentRunRequest",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "after_seq", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.ApproveAgentStepRequest
 */
export const ApproveAgentStepRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ApproveAgentStepRequest",
  () => [
    { no: 1, name: "agent_run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "step_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "approved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "feedback", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetAgentRunRequest
 */
export const GetAgentRunRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetAgentRunRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAgentRunsRequest
 */
export const ListAgentRunsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAgentRunsRequest",
  () => [
    { no: 1, name: "agent_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(AgentRunStatus), opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListAgentRunsResponse
 */
export const ListAgentRunsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAgentRunsResponse",
  () => [
    { no: 1, name: "runs", kind: "message", T: AgentRun, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.KnowledgeDocument
 */
export const KnowledgeDocument = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.KnowledgeDocument",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "chunk_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.UploadKnowledgeDocumentRequest
 */
export const UploadKnowledgeDocumentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UploadKnowledgeDocumentRequest",
  () => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListKnowledgeDocumentsRequest
 */
export const ListKnowledgeDocumentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListKnowledgeDocumentsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListKnowledgeDocumentsResponse
 */
export const ListKnowledgeDocumentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListKnowledgeDocumentsResponse",
  () => [
    { no: 1, name: "documents", kind: "message", T: KnowledgeDocument, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.DeleteKnowledgeDocumentRequest
 */
export const DeleteKnowledgeDocumentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteKnowledgeDocumentRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteKnowledgeDocumentResponse
 */
export const DeleteKnowledgeDocumentResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteKnowledgeDocumentResponse",
  [],
);

/**
 * @generated from message omnios.v1.GetKnowledgeChunksRequest
 */
export const GetKnowledgeChunksRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetKnowledgeChunksRequest",
  () => [
    { no: 1, name: "document_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.KnowledgeChunk
 */
export const KnowledgeChunk = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.KnowledgeChunk",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "chunk_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetKnowledgeChunksResponse
 */
export const GetKnowledgeChunksResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetKnowledgeChunksResponse",
  () => [
    { no: 1, name: "chunks", kind: "message", T: KnowledgeChunk, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AgentSession
 */
export const AgentSession = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AgentSession",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agent_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "parent_session", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "file_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "total_size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "memory_version", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 22, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
    { no: 21, name: "last_active_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListAgentSessionsRequest
 */
export const ListAgentSessionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAgentSessionsRequest",
  () => [
    { no: 1, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAgentSessionsResponse
 */
export const ListAgentSessionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAgentSessionsResponse",
  () => [
    { no: 1, name: "sessions", kind: "message", T: AgentSession, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreateAgentSessionRequest
 */
export const CreateAgentSessionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateAgentSessionRequest",
  () => [
    { no: 1, name: "fork_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateAgentSessionResponse
 */
export const CreateAgentSessionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateAgentSessionResponse",
  () => [
    { no: 1, name: "session", kind: "message", T: AgentSession },
  ],
);

/**
 * @generated from message omnios.v1.GetAgentSessionRequest
 */
export const GetAgentSessionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetAgentSessionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteAgentSessionRequest
 */
export const DeleteAgentSessionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteAgentSessionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteAgentSessionResponse
 */
export const DeleteAgentSessionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteAgentSessionResponse",
  [],
);

/**
 * @generated from message omnios.v1.GcAgentSessionsRequest
 */
export const GcAgentSessionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GcAgentSessionsRequest",
  () => [
    { no: 1, name: "older_than_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GcAgentSessionsResponse
 */
export const GcAgentSessionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GcAgentSessionsResponse",
  () => [
    { no: 1, name: "deleted_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.AgentFileEntry
 */
export const AgentFileEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AgentFileEntry",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "s3_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sha256", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "tier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "modified_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListAgentSessionFilesRequest
 */
export const ListAgentSessionFilesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAgentSessionFilesRequest",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAgentSessionFilesResponse
 */
export const ListAgentSessionFilesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAgentSessionFilesResponse",
  () => [
    { no: 1, name: "files", kind: "message", T: AgentFileEntry, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ResolveAgentFilePathRequest
 */
export const ResolveAgentFilePathRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ResolveAgentFilePathRequest",
  () => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ResolveAgentFilePathResponse
 */
export const ResolveAgentFilePathResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ResolveAgentFilePathResponse",
  () => [
    { no: 1, name: "s3_urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "presigned_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RequestAgentApprovalRequest
 */
export const RequestAgentApprovalRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RequestAgentApprovalRequest",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RequestAgentApprovalResponse
 */
export const RequestAgentApprovalResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RequestAgentApprovalResponse",
  [],
);

/**
 * @generated from message omnios.v1.AddAgentStepRequest
 */
export const AddAgentStepRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddAgentStepRequest",
  () => [
    { no: 1, name: "run_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AddAgentStepResponse
 */
export const AddAgentStepResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddAgentStepResponse",
  [],
);

/**
 * @generated from message omnios.v1.AgentProfile
 */
export const AgentProfile = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AgentProfile",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "system_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tool_set", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "ui_layout", kind: "message", T: Struct },
    { no: 8, name: "default_model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "run_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "capabilities", kind: "message", T: Struct },
    { no: 11, name: "is_template", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "default_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
    { no: 21, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateAgentProfileRequest
 */
export const CreateAgentProfileRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateAgentProfileRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "system_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "tool_set", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "ui_layout", kind: "message", T: Struct },
    { no: 6, name: "default_model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "run_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "capabilities", kind: "message", T: Struct },
    { no: 9, name: "from_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "default_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateAgentProfileRequest
 */
export const UpdateAgentProfileRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateAgentProfileRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "system_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "tool_set", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "ui_layout", kind: "message", T: Struct },
    { no: 7, name: "default_model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "run_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "capabilities", kind: "message", T: Struct },
    { no: 10, name: "default_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteAgentProfileRequest
 */
export const DeleteAgentProfileRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteAgentProfileRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteAgentProfileResponse
 */
export const DeleteAgentProfileResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteAgentProfileResponse",
  [],
);

/**
 * @generated from message omnios.v1.ListAgentProfilesRequest
 */
export const ListAgentProfilesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAgentProfilesRequest",
  () => [
    { no: 1, name: "include_system_templates", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListAgentProfilesResponse
 */
export const ListAgentProfilesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListAgentProfilesResponse",
  () => [
    { no: 1, name: "profiles", kind: "message", T: AgentProfile, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetAgentProfileRequest
 */
export const GetAgentProfileRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetAgentProfileRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CodeTemplate
 */
export const CodeTemplate = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CodeTemplate",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "git_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "git_branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "git_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "is_system", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateCodeTemplateRequest
 */
export const CreateCodeTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateCodeTemplateRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "git_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "git_branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteCodeTemplateRequest
 */
export const DeleteCodeTemplateRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteCodeTemplateRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteCodeTemplateResponse
 */
export const DeleteCodeTemplateResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteCodeTemplateResponse",
  [],
);

/**
 * @generated from message omnios.v1.ListCodeTemplatesRequest
 */
export const ListCodeTemplatesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCodeTemplatesRequest",
  () => [
    { no: 1, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListCodeTemplatesResponse
 */
export const ListCodeTemplatesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListCodeTemplatesResponse",
  () => [
    { no: 1, name: "templates", kind: "message", T: CodeTemplate, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GenerateProductSeoRequest
 */
export const GenerateProductSeoRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GenerateProductSeoRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fields", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GenerateProductSeoResponse
 */
export const GenerateProductSeoResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GenerateProductSeoResponse",
  () => [
    { no: 1, name: "seo_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "seo_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "applied", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.TranslateProductRequest
 */
export const TranslateProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TranslateProductRequest",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.TranslateProductResponse
 */
export const TranslateProductResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TranslateProductResponse",
  () => [
    { no: 1, name: "translated_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "translated_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "saved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

